import { gql } from "@apollo/client";

export const GET_INITIATIVE_REFERRALS = gql`
  query GetInitiativeServicesReferrals(
    $initiativeId: String!
    $organizationId: String!
    $status: ReferralStatus
  ) {
    getInitiativeServicesReferrals(
      initiativeId: $initiativeId
      organizationId: $organizationId
      status: $status
    ) {
      id
      from
      userId
      eligibilityStatus
      serviceId
      serviceName
      orgId
      status
      isSelfReferral
      user {
        firstName
        lastName
        email
        country
      }
    }
  }
`;
